import { Component, Input, OnDestroy, OnInit , Pipe, PipeTransform, ViewChild} from '@angular/core';
import { BehaviorSubject, Observable, of, Subject, Subscription } from 'rxjs';
import { HomePageService } from '../_services/homepage.services';
import { InsuranceService } from '../_services/insurance.services';
import { DocumentService } from '../_services/document.services';
import { exhaustMap, map } from 'rxjs/operators';
import { Policy } from '../_models/policy.model';
import { Document } from '../_models/document.model';
import { HomeSlide } from '../_models/homeslide.model';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { UserModel } from '../../modules/auth/_models/user.model';
import { AuthService } from '../../modules/auth/_services/auth.service';
import { LayoutService } from '../../_metronic/core';
import { DomSanitizer } from '@angular/platform-browser'
import {NgbModal, ModalDismissReasons, NgbConfig, NgbCarousel, NgbSlideEvent, NgbSlideEventSource, NgbCarouselConfig} from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../../environments/environment';


//@Pipe({ name: 'safeHtml' })
@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.scss'],
  providers: [NgbCarouselConfig]
})
export class HomepageComponent implements OnInit, OnDestroy  {
    
    showNavigationArrows = false;
    showNavigationIndicators = false;
    
    
    extrasUserDropdownStyle: 'light' | 'dark' = 'light';
    user$: Observable<UserModel>;
    _user:UserModel;
    closeResult: string;
    evn: any = environment;
    public slides$: Observable<any>;
    private slidesSubject = new Subject<any>();
    totalesRamos: any;
    detalleRamos: any;
    loadingSlide: boolean = false;
    loadingTotalesRamos: boolean = false;
    loadingDetalleRamo: boolean = false;
    tipoProceso = "";
    headerMenuSelfDisplay = true;
    subscriptions = [];
    permissionMenu: any;

  
    constructor(
        private layout: LayoutService,
        private auth: AuthService,
        public homeService: HomePageService,
        private modalService: NgbModal,
        ngbConfig: NgbCarouselConfig
    ) {
        ngbConfig.showNavigationArrows = true;
        ngbConfig.showNavigationIndicators = true;
     }

  async ngOnInit() {
    

    this.extrasUserDropdownStyle = this.layout.getProp(
      'extras.user.dropdown.style'
    );

    this.user$ = this.auth.currentUserSubject.asObservable();
    let sb = this.user$.subscribe(user=> {
      this._user = user;
    });
    this.subscriptions.push(sb);

   

    //const sb1 = this.insuranceService.isLoading$.subscribe(res => this.isLoading = res);
    //const sb2 = this.documentService.isLoading$.subscribe(res => this.isLoading = res);
    //this.subscriptions.push(sb1);
    //this.subscriptions.push(sb2);

    //this.insuranceService.fetch();

    this.slides$ = this.slidesSubject.asObservable();
    this.homeService.getSlides().then(response=> {
        if(response) {
            this.slidesSubject.next(response);
        }
    });
    
    this.totalesRamos = this.homeService.getTotalesRamos();

    this.permissionMenu = JSON.parse(localStorage.getItem("permissionMenu"))[0];
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }

  transform(value) {
    //return this.sanitized.bypassSecurityTrustHtml(value);
  }
 
  onclickModalTotales(content, IdTipoProceso, tipoProceso) {
    this.loadingDetalleRamo = true;

    this.modalService.open(content).result.then((result) => {
      console.log(result)
    }, (reason) => { // this.getDismissReason(reason)
        
    });

    this.detalleRamos = this.homeService.getDetalleRamo("IdTipoProceso="+IdTipoProceso).finally(() => {
      this.tipoProceso = tipoProceso;
      this.loadingDetalleRamo = false;
    });    
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
        return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
        return 'by clicking on a backdrop';
    } else {
        return  `with: ${reason}`;
    }
}
}
